import { render, staticRenderFns } from "./DocumentDetailCreate2.vue?vue&type=template&id=8169305e"
import script from "./DocumentDetailCreate2.vue?vue&type=script&lang=js"
export * from "./DocumentDetailCreate2.vue?vue&type=script&lang=js"
import style0 from "./DocumentDetailCreate2.vue?vue&type=style&index=0&id=8169305e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports